import { render, staticRenderFns } from "./NonConformityAction.vue?vue&type=template&id=2dd9270a&"
import script from "./NonConformityAction.vue?vue&type=script&lang=js&"
export * from "./NonConformityAction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports